import React, {use, useCallback, useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Link, useLocation, useParams} from "react-router-dom";
import LoginPopUp from "../../loginpopup.js";
import SidebarMenuList from "../../../includes/sidebarMenuList";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import {getUserData} from "../../../apihelper/portfolio";
import UserAvatar from "../../userAvatar.js";
import {
    getAlertCountAPI,
    getTop7DayPerformerGainerLooserAPI,
    getTop7DayPerformerGainerLooserOneAPI,
} from "../../../apihelper/profile";
import {useNavigate} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Autocomplete, CircularProgress, TextField, useMediaQuery} from "@mui/material";
import json2mq from "json2mq";
import IconButton from "@mui/material/IconButton";
import Header3 from "../../../common/header/Header3";
import "./portfolioAnalysis.css";
import {getmultiPortfolioPublic} from "../../../apihelper/portfolio";
import PortfolioChart from "./Chart/PortfolioChart";
import CompositionChart from "./Chart/CompositionChart";
// import {PerformanceCompositionTable} from "./Chart/PerformanceCompositionTable";
import {UnderperformerCurrently} from "./Chart/UnderperformerCurrently";
import {PerformanceCompositionTable} from "./Chart/PerformanceCompositionTable";
import Recommendation from "./Chart/Recommendation";
import {OtherRecommendation} from "./Chart/otherRecommendations";
import PerformanceTable from "./Chart/PerformanceTable";
import {ReactComponent as NotificationIcon} from "../../../pages/account/profile/profile_icon/notification-icon.svg";
import {useRef} from "react";
import PromoBanner from "../../promoBanner.js";
import {tabLink} from "../../../common/constant/tablink.jsx";
import BottomTab from "../../../common/hooks/BottomTab.jsx";
import {getSymbolbyPortfolioid} from "../../../apihelper/homepage";
import {getTotalunit} from "../../../apihelper/cryptocurrencylist";
import {copyToPortfolio} from "../../../apihelper/portfolio";
import {getFetchdropdown} from "../../../apihelper/cryptocurrencylist";

import {
    FormControlLabel,
    FormLabel,
    DialogTitle,
    DialogContent,
    DialogActions,
    Radio,
    RadioGroup,
    Popover,
    Chip,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import CreatableSelect from "react-select/creatable";
import Alert from "@mui/material/Alert";
import {Button, Grid, Card, BottomNavigation, Checkbox} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";

const drawerWidth = 292;
const PortfolioAnalysis = (props) => {
    const {window1} = props;

    // get portfolio name
    const {portfolioname} = useParams();

    // get current path
    const location = useLocation();

    // const {prePortfolioName, all_portfolio} = state || {};
    const navigate = useNavigate();
    const [unreadAlerts, setUnreadAlerts] = React.useState(0);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const handleBackClick = () => navigate(-1);
    const [selectedPortfolio, setSelectedPortfolio] = React.useState();
    const [myPortfolio, setMyPortfolio] = React.useState([]);
    const [loadingMyPortfolio, setLoadingMyPortfolio] = React.useState(false);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [selectedPortfolioLoading, setSelectedPortfolioLoading] = React.useState(false);
    const container = window1 !== undefined ? () => window1().document.body : undefined;
    const [searchText, setSearchText] = useState("");
    const [textCopied, setTextCopied] = useState(false);

    useEffect(() => {
        if (portfolioname) {
            const updatedText = portfolioname.replace(/-/g, " ");
            setSearchText(updatedText);
            setInputValue(updatedText); // <-- Also show it in Autocomplete
            console.log("here it is", portfolioname);
        }
    }, [portfolioname]);

    const fetchData = useCallback(
        (sortKey, sortType) => {
            setLoadingMyPortfolio(true);
            console.log("multi public", portfolioname.replace(/-/g, " "));

            if (!selectedPortfolio) {
                getmultiPortfolioPublic({
                    search_text: portfolioname.replace(/-/g, " "),
                }).then((res) => {
                    if (res.code === "200") {
                        setMyPortfolio(res.data);
                        const slugArray = res.data[0]?.slugs.map((item) => item.slug);

                        const selectedPortfolioData =
                            portfolioname &&
                            res.data.find(
                                (portfolio) =>
                                    portfolio.portfolio_name.toLowerCase().replace(/\s+/g, "-") ===
                                    portfolioname.toLowerCase()
                            );

                        console.log("MAtching found", selectedPortfolioData);
                        // If a matching portfolio is found, set it to the selected portfolio
                        if (portfolioname) {
                            const slugArray = selectedPortfolioData.slugs.map((item) => item.slug);
                            setSelectedPortfolio({
                                portfolio_id: selectedPortfolioData.portfolio_type_id,
                                portfolio_name: selectedPortfolioData.portfolio_name,
                                total_portfolio_value: selectedPortfolioData.total_portfolio_value,
                                cryptoList: slugArray,
                            });
                        } else {
                            setSelectedPortfolio({
                                portfolio_id: res.data[0].portfolio_type_id,
                                portfolio_name: res.data[0].portfolio_name,
                                total_portfolio_value: res.data[0].total_portfolio_value,
                                cryptoList: slugArray,
                            });
                        }

                        setLoadingMyPortfolio(false);
                    } else {
                        setLoadingMyPortfolio(false);
                        console.error("fetchdata1 is called 200 not");
                    }
                });
            } else {
                setLoadingMyPortfolio(false);
            }
        },
        [userData]
    );
    const [my7DaysPortfolio, setMy7DaysPortfolio] = useState();

    const fetchSevenDayPerformerData = useCallback(() => {
        if (!selectedPortfolio?.portfolio_id) {
            console.error("selectedPortfolio not available");
            return;
        }
        getTop7DayPerformerGainerLooserOneAPI(selectedPortfolio?.portfolio_id)
        .then((res) => {
            if (res.code === 200) {
                setMy7DaysPortfolio(res.data);
                // setTableData(res.data["gainer_data"] || []);
            } else {
                setMy7DaysPortfolio(null);
                console.error("Fetch data error: response code not 200");
            }
            // setLoading(false);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            // setLoading(false);
        });
    }, [userData, selectedPortfolio]);

    let url = "";
    React.useEffect(() => {
        fetchSevenDayPerformerData();
    }, [selectedPortfolio]);

    const handleLoginClick = () => {
        const originalUrl = window.location.pathname + window.location.search;
        sessionStorage.setItem("originalUrl", originalUrl);

        fetch(`${process.env.REACT_APP_API_URL}/initiategooglelogin?originalUrl=${encodeURIComponent(originalUrl)}`)
        .then((res) => res.json())
        .then((res) => {
            if (res.google_url) {
                window.location.replace(res.google_url); // Redirect to Google login
            } else {
                console.error("Failed to get Google login URL");
            }
        })
        .catch((err) => console.error("Error initiating login:", err));
    };

    const handleModalClose = () => {
        // Close the modal and reset the URL to the current page
        setLoginModalOpen(false);
        navigate("/portfolio-gallery", {replace: true});
    };
    const [symbolslugdata, setsymbolslugdata] = useState([]);
    const [loadermodal, setloadermodal] = useState(false);
    const [unitValues, setUnitValues] = useState(Array(symbolslugdata.length).fill(""));
    const [showModal, setShowModal] = useState(false);
    const [options, setOptions] = useState([]);
    const [hasSelectedOption, setHasSelectedOption] = useState(false);
    const [Usablewallet, setUsablewallet] = useState("");
    const [isChecked, setIsChecked] = useState(Array(symbolslugdata.length).fill(false));
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [selectedOption, setSelectedOption] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dataslug, setdataslug] = useState("");
    const [dropDown, setdropDown] = useState([]);
    const [totalUnits, setTotalUnits] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [severity, setSeverity] = useState("info");
    const [newOptionValue, setNewOptionValue] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [user_role, setuser_role] = useState("");

    const fetchDropdownOptions = async () => {
        if (userData) {
            getFetchdropdown({
                user_id: userData.user_id,

                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    const newOptions = res.data.map((item) => ({value: item.id, label: item.name}));
                    setOptions(newOptions);
                    setuser_role(res.user_role);
                } else {
                    console.error("Data fething error");
                }
            });
        }
    };
    useEffect(() => {
        if (dropDown) {
            fetchDropdownOptions();
        }
    }, []); //remove dropdown conditon here
    const handleChange2 = (e) => {
        const value = e.target.value;
        if (value.includes("-")) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
            setNewOptionValue(value);
        }
    };
    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbaropen(false);
    };

    const [viewprofile, setviewprofile] = useState(false);
    const [localUserData, setLocalUserData] = useState(undefined);
    const [influencerName, setInfluencerName] = useState("");
    const [influencerProfilePhoto, setInfluencerProfilePhoto] = useState(null);

    const handleProfileClick = () => {
        // console.log("PF name : ",portfolioName);
        const encodedPortfolioName = encodeURIComponent(portfolioname);
        navigate(`../../influencer/${influencerName.replace(/\s+/g, "-")}`, {
            state: {portfolioname},
        });
    };

    useEffect(() => {
        //console.log(100)
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        setLocalUserData(userData);
        const user_idValue = userData ? userData.user_id : 0;
        //console.log("User_Idvalue"+user_idValue);
        const user_token = userData ? userData.token : 0;
        // console.log("User_token"+user_token);

        getUserData({
            user_id: user_idValue,
            portfolio_id: portfolioname,
            Token: user_token,
        }).then((res) => {
            if (res.code === "200") {
                console.log("User data fetched successfully: ", res.data);
                const userData = res.data[0];
                if (!userData.name) {
                    setviewprofile(false);
                    console.log("view profile:", userData);
                } else {
                    setInfluencerName(userData.name);
                    setInfluencerProfilePhoto(userData.photo);
                    console.log("view profile", influencerProfilePhoto);
                    setviewprofile(true);
                }
            } else {
                console.log("Data fething error");
            }
        });
    }, []);
    const handleDialogSubmit = () => {
        const newOption = {value: newOptionValue, label: newOptionValue};
        setOptions([...options, newOption]);
        setSelectedOption(newOption);
        setIsDialogOpen(false);
        getTotalunit({
            user_id: userData.user_id,
            slug: dataslug,
            portfolio_type_id: newOption.value,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setTotalUnits(res.total_uint);
                setNewOptionValue("");
                setUsablewallet(res.wallet_amount);
            } else {
                console.error("Data fething error");
            }
        });
    };

    const handleChange1 = async (selectedOption, slug) => {
        setIsOptionSelected(true);
        if (selectedOption && selectedOption._isNew_) {
            setIsDialogOpen(true);
            setSelectedOption(null);
            setIsOptionSelected(false);
            setdataslug(slug);
        } else if (!selectedOption) {
            setSelectedOption(null);
            setIsOptionSelected(false);
            setShowAlert(false);

            return;
        } else {
            const selectedValue = selectedOption.value;
            if (selectedValue.includes("-")) {
                setErrorMessage("Hyphens are not allowed in the option.");
                setShowAlert(true);
                return;
            }
            setShowAlert(false);
            setSelectedOption(selectedOption);
            getTotalunit({
                user_id: userData.user_id,
                slug: slug,
                portfolio_type_id: selectedOption.value,
                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    setTotalUnits(res.total_uint);
                    setUsablewallet(res.wallet_amount);
                } else {
                    console.error("Data fething error");
                }
            });
        }
    };
    const handleChange = async (selectedOption, slug) => {
        if (selectedOption && selectedOption.__isNew__) {
            setIsDialogOpen(true);
            setSelectedOption(null);
            setdataslug(slug);
        } else if (!selectedOption) {
            setSelectedOption(null);
            setShowAlert(false);
            return;
        } else {
            const selectedValue = selectedOption.value;
            if (selectedValue.includes("-")) {
                setErrorMessage("Hyphens are not allowed in the option.");
                setShowAlert(true);
                return;
            }
            setShowAlert(false);

            setSelectedOption(selectedOption);
            getTotalunit({
                user_id: userData.user_id,
                slug: slug,
                portfolio_type_id: selectedOption.value,
                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    setTotalUnits(res.total_uint);
                    setUsablewallet(res.wallet_amount);
                } else {
                    console.error("Data fething error");
                }
            });
        }
    };

    const [slugpopupdata, setSlugpopupdata] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });

    const handleCloseModal = () => {
        setShowModal(false);
        setTotalUnits(0);
        setUsablewallet("");
        setSelectedOption([]);
    };
    const handleOpenSelect = () => {
        setShowAlert(false);
        setdropDown(true);
    };
    const handleCreate = async (inputValue) => {
        setTotalUnits(0);
        setUsablewallet("");

        if (options.find((option) => option.value === inputValue)) {
            return;
        }
        const newOption = {value: inputValue, label: inputValue};
        const newOptions = [...options, newOption];
        setOptions(newOptions);
        const createdOption = newOptions.find((option) => option.value === inputValue);
        if (createdOption) {
            handleChange(createdOption);
        }
    };

    const handleCopy = (portfolio_id) => {
        if (!userData) {
            const originalUrl = window.location.pathname;
            sessionStorage.setItem("originalUrl", originalUrl);
            handleLoginClick();
        } else {
            setloadermodal(true);
            setUnitValues({});
            setShowModal(true);
            getSymbolbyPortfolioid({
                user_id: userData.user_id,
                portfolio_id: portfolio_id,
                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    setsymbolslugdata(res.data);
                    setloadermodal(false);
                } else {
                    console.error("Data fetching error");
                }
            });
        }
    };
    const handleCheckboxChange = (event, idx) => {
        const newChecked = [...isChecked];
        newChecked[idx] = event.target.checked;
        setIsChecked(newChecked);
        const anyChecked = newChecked.some((checked) => checked);
        setIsButtonEnabled(anyChecked);
    };
    const handleUnitChange = (event, idx) => {
        const {value} = event.target;
        setUnitValues((prevState) => {
            const updatedUnitValues = Array.isArray(prevState) ? [...prevState] : [];
            updatedUnitValues[idx] = value;
            return updatedUnitValues;
        });
    };
    const handleClickphotoGallery = () => {
        const checkedData = symbolslugdata.filter((obj, idx) => isChecked[idx]);
        if (checkedData.length > 0) {
            setMsgforUpdatePortfolio("loading...");

            setSnackbaropen(true);
            setShowModal(true);
            setSeverity("info");
            setMsgforUpdatePortfolio("loading...");
            const portfolioId =
                selectedOption && !isNaN(parseInt(selectedOption.value)) ? parseInt(selectedOption.value) : 0;
            const existingPortfolio = portfolioId > 0 ? "yes" : "no";

            const checkedUnitValues = Array.isArray(unitValues) ? unitValues.filter((unit, idx) => isChecked[idx]) : [];

            const portfolioData = checkedData.map((obj, idx) => ({
                slug: obj.slug_name,
                unit: checkedUnitValues[idx] || "",
            }));

            copyToPortfolio({
                portfolio_type_id: portfolioId,
                portfolio_name: selectedOption ? selectedOption.label : "", // Ensure selectedOption is defined
                portfolio_data: portfolioData,

                existing_portfolio: existingPortfolio,
                user_id: userData.user_id,

                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    setUnitValues({});
                    setShowModal(false);

                    setSeverity("info");
                    setMsgforUpdatePortfolio(res.message);
                    setIsChecked(new Array(symbolslugdata.length).fill(false));
                    navigate(`/my-portfolio/${res.portfolio_type_id}/${encodeURIComponent(selectedOption.label)}`);
                    setSelectedOption([]);
                    setTotalUnits(0);
                    setUsablewallet("");
                } else {
                    setSeverity("error");
                    setSelectedOption([]);
                    setMsgforUpdatePortfolio(res.message);
                }
            });
        } else {
            setSeverity("error");
            setSelectedOption([]);
        }
    };

    React.useEffect(() => {
        fetchData();
    }, [searchText]);

    React.useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlerts = async () => {
            const response = await getAlertCountAPI(userData?.user_id);
            if (response?.unread_notifications) {
                setUnreadAlerts(response?.unread_notifications);
            }
        };

        fetchAlerts();
    }, []);

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const drawer = (
        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
            <SidebarMenuList />
        </div>
    );

    const [inputValue, setInputValue] = useState(""); // Track input value

    useEffect(() => {
        // If the selected portfolio's name matches the current input value, set input to null
        if (selectedPortfolio?.portfolio_name) {
            setInputValue(""); // Reset input value when portfolio is selected
        }
    }, [selectedPortfolio]); // Run effect when selectedPortfolio changes

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue || ""); // Allow typing freely
        setSearchText(newInputValue);
    };

    const [path, setPath] = useState("/");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path.includes(href);

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "4px 10px" : "4px 4px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: "600",
            fontSize: "15px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                        fontSize: "14px",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "14px",
                        }}
                    >
                        {[tabLink["portfolio_detail"], tabLink["screener"], tabLink["reward_history"]].map(
                            (tab, index) => (
                                <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                    <div style={topTabStyle(isActive(tab.href))}>
                                        <img
                                            src={window?.constants?.asset_path + tab.icon}
                                            alt="icon"
                                            style={{
                                                marginRight: "5px",
                                                height: tab.icon_width || "25px",
                                                filter: iconFilter(isActive(tab.href)),
                                            }}
                                        />
                                        {!mediaQueryVar ? tab.mobile_name : tab.name}
                                    </div>
                                </Link>
                            )
                        )}
                    </div>
                    {/* Bottom Tabs */}
                    <BottomTab
                        tabs={[tabLink["subscription"], tabLink["presale"], tabLink["profile"]]}
                        handleLoginClick={handleLoginClick}
                    />

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>
            </div>
        );
    };

    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path.includes(href);

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "3px 6px" : "1px 6px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "12px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {[tabLink["portfolio_detail"], tabLink["screener"]].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height: "20px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                        <UserAvatar />

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[tabLink["subscription"], tabLink["presale"], tabLink["profile"]]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    const inputRef = useRef(null);

    const [isFocused, setIsFocused] = useState(false);
    const [hasJustSelected, setHasJustSelected] = useState(false);
    const handleInputBlur = () => {
        setIsFocused(false);
    };

    const handleInputFocus = () => {
        setIsFocused(true);
        if (hasJustSelected) {
            setHasJustSelected(false); // reset flag, do not clear input
            return;
        }
        setInputValue(""); // clear input if not just selected
    };

    return (
        <div style={{width: "100vw", maxWidth: "100%", overflowX: "hidden"}}>
            <div className="d-flex row  w-100 m-0 mb-5">
                <Helmet>
                    <title>
                        {selectedPortfolio?.portfolio_name
                            ? selectedPortfolio.portfolio_name.charAt(0).toUpperCase() +
                              selectedPortfolio.portfolio_name.slice(1)
                            : "Portfolio"}{" "}
                        - Portfolio Analysis
                    </title>
                </Helmet>
                <Box
                    component="nav"
                    sx={{
                        width: "100%", // Take full width on mobile
                    }}
                    aria-label="mailbox folders"
                >
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            "& .MuiDrawer-paper": {
                                width: "280px", // Adjust width for mobile
                                backgroundColor: "white",
                                color: "#727376",
                            },
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Box>
                {isLoginModalOpen && (
                    <LoginPopUp
                        isLoginModalOpen={isLoginModalOpen}
                        setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                        onClose={handleModalClose}
                    />
                )}
                <Header3 />
                <div className="profile-section col" style={{maxWidth: "100%"}}>
                    <div className="profile-container  profile-container-lg">
                        {/* Profile tabs */}
                        <div className="d-flex justify-content-between my-5">
                            {mediaQueryVar ? (
                                <>
                                    <div
                                        style={{
                                            position: "fixed",
                                            top: 0,
                                            left: drawerWidth,
                                            width: `calc(100% - ${drawerWidth}px)`,
                                            backgroundColor: "#ffffff",
                                            zIndex: 1000,
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            height: "100px", // You may need to increase this if banner + nav exceeds 100px
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <PromoBanner />
                                        <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                                    </div>
                                </>
                            ) : (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0, // aligns it to the right of the sidebar
                                        width: "100%", // takes full width minus sidebar
                                        backgroundColor: "#ffffff",
                                        zIndex: 1000,
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        height: "100px",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <PromoBanner />
                                    <TopNavigationMobile unreadAlerts={unreadAlerts} />
                                </div>
                            )}
                        </div>

                        {/* section 1 */}
                        <div className="section">
                            {selectedPortfolio?.portfolio_name && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row", // Always row to keep items side by side
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexWrap: "wrap", // Allow wrapping inside name box, not the layout
                                        gap: "20px",
                                        marginTop: "-100px",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            padding: "5px 10px",
                                            fontWeight: 700,
                                            fontSize: mediaQueryVar ? "20px" : "16px",
                                            border: "1.8px solid rgba(24, 119, 242, 1)",
                                            color: "#000000",
                                            background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                            borderRadius: "10px",
                                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                            cursor: "default",
                                            minHeight: "56px",
                                            height: "auto",
                                            maxWidth: "80vw",
                                            textAlign: "center",
                                            wordBreak: "break-word",
                                            whiteSpace: "normal",
                                            lineHeight: 1.2, // tighter lines when wrapping
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {selectedPortfolio.portfolio_name.charAt(0).toUpperCase() +
                                            selectedPortfolio.portfolio_name.slice(1)}
                                    </Box>

                                    {viewprofile && (
                                        <Button
                                            variant="outlined"
                                            style={{
                                                border: "none",
                                                minWidth: "0", // avoid big default button padding
                                                padding: 0,
                                            }}
                                            onClick={handleProfileClick}
                                        >
                                            <img
                                                width={41}
                                                height={40}
                                                style={{
                                                    borderRadius: "50%",
                                                    border: "2px solid black",
                                                    display: "block",
                                                }}
                                                alt="Influencer Profile"
                                                src={influencerProfilePhoto || "/default-profile.png"}
                                            />
                                        </Button>
                                    )}
                                </Box>
                            )}

                            {/* Top gainer */}
                            <div
                                className="d-flex flex-column flex-md-row justify-content-center mt-5"
                                style={{
                                    marginRight: mediaQueryVar ? "5px" : "",
                                    alignItems: mediaQueryVar ? "center" : "",
                                }}
                            >
                                {/* {top7DayPerformer?.seven_days?.length > 0 && top7DayPerformer?.thirty_days?.length > 0 && ( */}
                                <>
                                    {" "}
                                    {my7DaysPortfolio?.gainer_data?.length > 0 && (
                                        <div
                                            className="d-flex justify-content-around top-gainer-card w-100"
                                            style={{marginBottom: mediaQueryVar ? "" : "40px", display:"flex",alignItems:"center"}}
                                        >
                                            <p>Top Gainer Last 7 Days</p>
                                            <img
                                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${my7DaysPortfolio?.gainer_data[0]?.crypto_id}.png`}
                                                alt="Gainer Icon"
                                            />
                                            {/* <p>{top7DayPerformer?.seven_days[0]?.slug}</p> */}
                                            <p style={{marginTop: "1%"}}>{my7DaysPortfolio?.gainer_data[0]?.slug}</p>
                                        </div>
                                    )}
                                    {my7DaysPortfolio?.looser_data?.length > 0 && (
                                        <div
                                            className="d-flex justify-content-around top-gainer-card w-100"
                                            style={{marginBottom: mediaQueryVar ? "" : "20px",display:"flex",alignItems:"center"}}
                                        >
                                            <p>Top Loser Last 7 Days</p>
                                            <img
                                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${my7DaysPortfolio?.looser_data[0]?.crypto_id}.png`}
                                                alt="Gainer Icon"
                                            />
                                            {/* <p>{top7DayPerformer?.thirty_days[0]?.slug}</p> */}
                                            <p style={{marginTop: "1%"}}>{my7DaysPortfolio?.looser_data[0]?.slug}</p>
                                        </div>
                                    )}
                                </>
                                {/* )} */}
                            </div>

                            <div
                                style={{
                                    marginRight: mediaQueryVar ? "25px" : "",
                                    marginTop: mediaQueryVar ? "-30px" : "",
                                    marginBottom: mediaQueryVar ? "" : "-150px",
                                }}
                            >
                                <PortfolioChart
                                    selectedPortfolio={selectedPortfolio?.portfolio_name}
                                    portfolioId={selectedPortfolio?.portfolio_id}
                                />
                            </div>
                        </div>

                        <div className="section" style={{marginTop: mediaQueryVar ? "-200px" : "-50px"}}>
                            <div style={{display: "flex", marginBottom: mediaQueryVar ? "2%" : "5%", gap: "30px"}}>
                                <p
                                    className={mediaQueryVar ? "label-2" : ""}
                                    style={{
                                        width: mediaQueryVar ? "" : "160px",
                                        background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                        borderRadius: "10px",
                                        border: "1.8px solid rgba(24, 119, 242, 1)",
                                        padding: mediaQueryVar ? "" : "10px 12px",
                                        fontSize: mediaQueryVar ? "" : "18px",
                                        fontWeight: mediaQueryVar ? "" : "700",
                                    }}
                                >
                                    Performance
                                </p>

                                <button
                                    className="edit-btn"
                                    style={{
                                        padding: mediaQueryVar ? "" : "8px 10px",
                                        fontSize: mediaQueryVar ? "" : "16px",
                                    }}
                                    onClick={() => handleCopy(selectedPortfolio?.portfolio_id)}
                                >
                                    <strong>Copy Portfolio</strong>
                                </button>
                            </div>

                            <PerformanceTable
                                selectedPortfolio={selectedPortfolio?.portfolio_name}
                                portfolioId={selectedPortfolio?.portfolio_id}
                            />
                        </div>

                        {/* Ssection 2 */}
                        <div className="section2" style={{marginTop: mediaQueryVar ? "80px" : "10px"}}>
                            <div style={{display: "flex", marginBottom: "30px", gap: "30px"}}>
                                <p
                                    className={mediaQueryVar ? "label-2" : ""}
                                    style={{
                                        width: mediaQueryVar ? "" : "auto",
                                        minWidth: mediaQueryVar ? "" : "160px",
                                        background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                        borderRadius: "10px",
                                        border: "1.8px solid rgba(24, 119, 242, 1)",
                                        padding: mediaQueryVar ? "" : "10px 12px",
                                        fontSize: mediaQueryVar ? "" : "18px",
                                        fontWeight: mediaQueryVar ? "" : "700",
                                    }}
                                >
                                    Composition
                                </p>

                                <button
                                    className="edit-btn"
                                    style={{
                                        padding: mediaQueryVar ? "" : "8px 10px",
                                        fontSize: mediaQueryVar ? "" : "16px",
                                    }}
                                    onClick={() => {
                                        const formattedName = selectedPortfolio?.portfolio_name?.replace(/\s+/g, "-");
                                        navigate(`/portfolio/${formattedName}`);
                                    }}
                                >
                                    <strong>View Portfolio</strong>
                                </button>
                            </div>
                            <CompositionChart portfolioId={selectedPortfolio?.portfolio_id} />
                        </div>

                        {/* Ssection 4 */}
                        <div className="section">
                            <div
                                style={{
                                    display: "flex",
                                    marginBottom: "30px",
                                    gap: "30px",
                                    marginTop: mediaQueryVar ? "-100px" : "-25vw",
                                }}
                            >
                                <p
                                    className={mediaQueryVar ? "label-2" : ""}
                                    style={{
                                        width: mediaQueryVar ? "" : "auto",
                                        background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                        borderRadius: "10px",
                                        border: "1.8px solid rgba(24, 119, 242, 1)",
                                        padding: mediaQueryVar ? "" : "10px 12px",
                                        fontSize: mediaQueryVar ? "" : "18px",
                                        fontWeight: mediaQueryVar ? "" : "700",
                                    }}
                                >
                                    Portfolio Composition
                                </p>

                                <button
                                    className="edit-btn"
                                    style={{
                                        padding: mediaQueryVar ? "" : "8px 10px",
                                        fontSize: mediaQueryVar ? "" : "16px",
                                    }}
                                    onClick={() => handleCopy(selectedPortfolio?.portfolio_id)}
                                >
                                    <strong>Copy Portfolio</strong>
                                </button>
                            </div>
                            <div style={{marginRight: mediaQueryVar ? "20px" : ""}}>
                                <PerformanceCompositionTable
                                    selectedPortfolio={selectedPortfolio?.portfolio_name}
                                    selectedPortfolioId={selectedPortfolio?.portfolio_id}
                                    selectedTotalPortfolioValue={selectedPortfolio?.total_portfolio_value}
                                />
                            </div>
                        </div>

                        {/* Ssection 5 */}
                        <div className="section" style={{marginTop: mediaQueryVar ? "-150px" : "-70px"}}>
                            <div style={{display: "flex", marginBottom: mediaQueryVar ? "-30px" : "50px", gap: "30px"}}>
                                <p
                                    className={mediaQueryVar ? "label-2" : ""}
                                    style={{
                                        width: mediaQueryVar ? "" : "auto",
                                        background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                        borderRadius: "10px",
                                        border: "1.8px solid rgba(24, 119, 242, 1)",
                                        padding: mediaQueryVar ? "" : "10px 12px",
                                        fontSize: mediaQueryVar ? "" : "18px",
                                        fontWeight: mediaQueryVar ? "" : "700",
                                    }}
                                >
                                    Replace/Reduce
                                </p>

                                <button
                                    className="edit-btn"
                                    style={{
                                        padding: mediaQueryVar ? "" : "8px 10px",
                                        fontSize: mediaQueryVar ? "" : "16px",
                                    }}
                                    onClick={() => {
                                        const formattedName = selectedPortfolio?.portfolio_name?.replace(/\s+/g, "-");
                                        navigate(`/portfolio/${formattedName}`);
                                    }}
                                >
                                    <strong>View Portfolio</strong>
                                </button>
                            </div>
                            <div style={{marginRight: mediaQueryVar ? "25px" : ""}}>
                                <UnderperformerCurrently
                                    portfolioName={selectedPortfolio?.portfolio_name}
                                    portfolioId={selectedPortfolio?.portfolio_id}
                                    cryptoList={selectedPortfolio?.cryptoList}
                                />
                            </div>
                        </div>

                        {/* Ssection 6 */}
                        <div className="section2" style={{marginTop: mediaQueryVar ? "100px" : "70px"}}>
                            <div style={{display: "flex", marginBottom: mediaQueryVar ? "30px" : "50px", gap: "30px"}}>
                                <p
                                    className={mediaQueryVar ? "label-2" : ""}
                                    style={{
                                        width: mediaQueryVar ? "" : "auto",
                                        background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                        borderRadius: "10px",
                                        border: "1.8px solid rgba(24, 119, 242, 1)",
                                        padding: mediaQueryVar ? "" : "10px 12px",
                                        fontSize: mediaQueryVar ? "" : "18px",
                                        fontWeight: mediaQueryVar ? "" : "700",
                                    }}
                                >
                                    Recommendations
                                </p>

                                <button
                                    className="edit-btn"
                                    style={{
                                        padding: mediaQueryVar ? "" : "8px 10px",
                                        fontSize: mediaQueryVar ? "" : "16px",
                                    }}
                                    onClick={() => {
                                        const formattedName = selectedPortfolio?.portfolio_name?.replace(/\s+/g, "-");
                                        navigate(`/portfolio/${formattedName}`);
                                    }}
                                >
                                    <strong>View Portfolio</strong>
                                </button>
                            </div>

                            <div style={{marginRight: "0px"}}>
                                <Recommendation
                                    selectedPortfolio={selectedPortfolio?.portfolio_name}
                                    selectedPortfolioId={selectedPortfolio?.portfolio_id}
                                    cryptoList={selectedPortfolio?.cryptoList}
                                />
                            </div>
                        </div>

                        <div className="section2" style={{marginTop: mediaQueryVar ? "100px" : "-40px"}}>
                            <div style={{display: "flex", marginBottom: mediaQueryVar ? "10px" : "50px", gap: "30px"}}>
                                <p
                                    className={mediaQueryVar ? "label-2" : ""}
                                    style={{
                                        width: mediaQueryVar ? "" : "auto",
                                        background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                        borderRadius: "10px",
                                        border: "1.8px solid rgba(24, 119, 242, 1)",
                                        padding: mediaQueryVar ? "" : "10px 12px",
                                        fontSize: mediaQueryVar ? "" : "18px",
                                        fontWeight: mediaQueryVar ? "" : "700",
                                    }}
                                >
                                    Other Recommendations
                                </p>
                            </div>

                            <div style={{marginRight: "0px"}}>
                                <OtherRecommendation
                                    portfolioName={selectedPortfolio?.portfolio_name}
                                    portfolioId={selectedPortfolio?.portfolio_id}
                                    cryptoList={selectedPortfolio?.cryptoList}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                open={showModal}
                onClose={handleCloseModal}
                PaperProps={{
                    sx: {
                        position: mediaQueryVar === false ? "fixed" : "static",
                        bottom: mediaQueryVar === false ? "0" : "",
                        left: mediaQueryVar === false ? "0" : "",
                        right: mediaQueryVar === false ? "0" : "",
                        margin: "0",
                        maxWidth: "100%",
                        minHeight: "50%", // Adjust max height if needed
                        borderRadius: mediaQueryVar === false ? "24px 24px 0 0" : "24px",
                        padding: mediaQueryVar === false ? "10px" : "10px",
                        alignItems: "center",
                        overflow: "hidden",
                    },
                }}
            >
                {mediaQueryVar === false && (
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <button
                            style={{
                                width: "48px",
                                height: "4px",
                                borderRadius: "100px",
                                background: "#E2E2E2",
                                border: "none",
                                margin: "10px",
                            }}
                        ></button>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        width: mediaQueryVar == false ? "100%" : "400px",
                        margin: "0",
                        maxHeight: "589px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            marginTop: "-10px",
                        }}
                    >
                        <Typography style={{fontWeight: "500", fontSize: "20.767px", paddingLeft: "20%"}} gutterBottom>
                            Add To Portfolio
                        </Typography>
                        <div className="primaryButton">
                            <img
                                className="frameIcon"
                                alt="primaryButton"
                                onClick={handleCloseModal}
                                src="../images/frame17.svg"
                                style={{
                                    background: "#F3F3F3",
                                    width: "25px",
                                    height: "25px",
                                    marginRight: mediaQueryVar === false ? "20px" : "",
                                }}
                            />
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            marginLeft: mediaQueryVar === false ? "0px" : "",
                            marginRight: mediaQueryVar === false ? "0px" : "",

                            flexDirection: "column",
                            marginBottom: "10px",
                        }}
                    >
                        <Typography
                            style={{fontSize: "13.845px", fontWeight: "500", marginBottom: "5px", color: "black"}}
                        >
                            Select Portfolio
                        </Typography>
                        <div style={{marginTop: "5px"}}>
                            {slugpopupdata.slugname}
                            <CreatableSelect
                                isClearable
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        borderRadius: "12px",
                                        border: "1px solid #1877F2",
                                        boxShadow: "none",
                                        minHeight: "40px",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        borderRadius: "8px",
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: "",
                                    }),
                                    dropdownIndicator: (provided) => ({
                                        ...provided,
                                        color: "#1877F2", // Add color to the dropdown indicator
                                        border: "1px solid #1877F2",
                                        padding: "5px",
                                        margin: "8px",
                                        borderRadius: "3.786px",
                                        "&:hover": {
                                            color: "#1877F2", // Add hover color to the dropdown indicator
                                        },
                                    }),
                                    indicatorSeparator: (provided) => ({
                                        display: "none", // Hide the vertical mark
                                    }),
                                }}
                                placeholder=""
                                onClick={(e) => handleOpenSelect()}
                                onChange={(options) => handleChange1(options)}
                                onCreateOption={handleCreate}
                                options={[
                                    {value: "", label: "Create new portfolio", _isNew_: true}, // Dynamic "create new option" item
                                    ...options, // Existing options
                                ]}
                                value={selectedOption}
                            />
                        </div>
                        {showAlert && (
                            <Alert severity="error" sx={{marginBottom: "10px"}}>
                                {errorMessage}
                            </Alert>
                        )}
                    </div>
                    <Typography
                        style={{
                            fontSize: "13.845px",
                            fontWeight: "500",
                            color: "#000",
                            marginTop: "16px",
                            marginBottom: "10px",
                            marginLeft: mediaQueryVar === false ? "0px" : "",
                        }}
                    >
                        Usable Wallets:
                        <span
                            style={{
                                fontSize: "12px",
                                color: "gray",
                                marginTop: "-10px",
                                marginBottom: "10px",
                                marginLeft: "10px",
                            }}
                        >
                            {Usablewallet}
                        </span>
                    </Typography>

                    <div
                        style={{
                            maxHeight: "150px",
                            overflowY: "scroll",
                            marginLeft: mediaQueryVar === false ? "0px" : "",
                            marginRight: mediaQueryVar === false ? "0px" : "",
                            display: "flex",
                            flexDirection: "column",
                            marginBottom: "10px",
                            "&::-webkit-scrollbar": {
                                display: "none",
                            },
                            "-ms-overflow-style": "none",
                            "scrollbar-width": "none",
                        }}
                    >
                        {loadermodal ? (
                            <div style={{textAlign: "center", marginTop: "10px"}}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <>
                                {symbolslugdata.map((obj, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            width: "100%",
                                            padding: "8px",
                                            background: "#F3F3F3",
                                            borderRadius: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        {/* Slug Details */}
                                        {/* Checkbox */}
                                        <Checkbox
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                flex: 0,
                                                minWidth: 0,
                                                marginRight: "10px",
                                            }}
                                            checked={isChecked[idx]}
                                            onChange={(event) => handleCheckboxChange(event, idx)}
                                        />
                                        <div style={{display: "flex", alignItems: "center", flex: 0, minWidth: 0}}>
                                            <img
                                                style={{
                                                    marginRight: "10px",
                                                    border: "2px solid #000",
                                                    borderRadius: "19px",
                                                    height: "32px",
                                                    width: "33.493px",
                                                }}
                                                alt=""
                                                src={obj.photo}
                                            />
                                            <div style={{display: "flex", flexDirection: "column"}}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "500",
                                                        marginBottom: "1px",
                                                        fontSize: "11.249px",
                                                        color: "#7F7F80",
                                                    }}
                                                >
                                                    {obj.slug_name}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        color: "black",
                                                        margin: "0",
                                                    }}
                                                >
                                                    {obj.slug_title}
                                                </Typography>
                                            </div>
                                        </div>

                                        {/* Price Details */}
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                marginRight: "-100px",
                                                alignItems: "center",
                                                flex: 1,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontWeight: "500",
                                                    marginBottom: "2px",
                                                    fontSize: "11.249px",
                                                    color: "#7F7F80",
                                                }}
                                            >
                                                PRICE
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontSize: "12.114px",
                                                    fontWeight: "500",
                                                    color: "black",
                                                    margin: "0",
                                                }}
                                            >
                                                {obj.current_price}
                                            </Typography>
                                        </div>
                                        <div style={{width: "30%"}}>
                                            <TextField
                                                size="small"
                                                InputProps={{
                                                    style: {
                                                        width: "100%",
                                                        height: "40px",
                                                        borderRadius: "12px",
                                                        border: "1px solid #1877F2",
                                                        textAlign: "center",
                                                        fontSize: "11px", // Adjust padding to decrease height
                                                        lineHeight: "1", // Ensure single line height for the input
                                                        boxShadow: "none", // Remove shadow if any
                                                        background: "#FFF",
                                                        fontWeight: "600",
                                                        fontfamily: "arial",
                                                    },
                                                }}
                                                type="number"
                                                placeholder="Enter number of Units"
                                                required
                                                className="placeholder-text"
                                                value={unitValues[idx] || ""} // Set the value from state
                                                onChange={(event) => handleUnitChange(event, idx)} // Pass index to handleUnitChange
                                            />
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                    <Button
                        style={{
                            color: "white",
                            marginLeft: mediaQueryVar === false ? "10px" : "",
                            marginRight: mediaQueryVar === false ? "10px" : "",
                            background: "#1877F2",
                            textTransform: "none",
                            width: mediaQueryVar === false ? "95%" : "100%",
                            height: "45px",
                            marginTop: "8px",
                            fontWeight: "700",
                            fontSize: "15.575px",
                            borderRadius: "23.363px",
                        }}
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={handleClickphotoGallery}
                        disabled={!isButtonEnabled}
                    >
                        Buy Now
                    </Button>

                    {!isOptionSelected && ( // Conditionally render the "Create new portfolio" button
                        <Button
                            style={{
                                marginBottom: mediaQueryVar === false ? "0px" : "",
                                marginLeft: mediaQueryVar === false ? "10px" : "",
                                marginRight: mediaQueryVar === false ? "10px" : "",
                                width: mediaQueryVar === false ? "95%" : "100%",
                                border: "1px solid #1877F2",
                                borderRadius: "23.363px",
                                marginTop: "10px",
                                color: "#1877F2",
                                textTransform: "none",
                                padding: "10px",
                                fontWeight: "700",
                                fontSize: "15.575px",
                            }}
                            variant="outline"
                            size="large"
                            onClick={() => setIsDialogOpen(true)}
                            disabled={isButtonEnabled}
                        >
                            Create new portfolio
                        </Button>
                    )}
                </div>
            </Dialog>

            <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingRight: "40px",
                    }}
                >
                    Create New Portfolio
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            setIsDialogOpen(false);
                            setNewOptionValue("");
                        }}
                        style={{position: "absolute", right: "13px", top: "8px"}}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div>
                        <TextField
                            autoFocus
                            label="Enter Name"
                            value={newOptionValue}
                            onChange={handleChange2}
                            fullWidth
                            margin="dense"
                        />
                        {showAlert && (
                            <Alert severity="error" sx={{marginTop: "8px"}}>
                                Hyphens are not allowed in the name.
                            </Alert>
                        )}
                    </div>
                </DialogContent>
                <DialogActions style={{marginRight: "14px"}}>
                    <Button
                        onClick={() => {
                            setIsDialogOpen(false);
                            setNewOptionValue("");
                        }}
                        style={{fontWeight: "bold"}}
                        variant="outlined"
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDialogSubmit}
                        variant="contained"
                        color="primary"
                        style={{fontWeight: "bold"}}
                        disabled={!newOptionValue.trim()}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbaropen}
                autoHideDuration={5000}
                onClose={closesnackbar}
                anchorOrigin={{vertical: "bottom", horizontal: "center"}}
            >
                <Alert severity={severity}>{msgforUpdatePortfolio}</Alert>
            </Snackbar>
        </div>
    );
};

export default PortfolioAnalysis;
